import Vue from 'vue'
import Router from 'vue-router'
import vueAuthInstance from './service/auth.js'
import MainLayout from './layouts/Main.vue'
import PrintLayout from './layouts/print/Main.vue'
import ReceiptLayout from './layouts/receipt/Main.vue'
import Login from './pages/auth/Login.vue'
import ChangePassword from './pages/profile/ChangePassword.vue'
import Dashboard from './pages/Dashboard.vue'
import EmployeeList from './pages/employee/List.vue'
import CustomerList from './pages/customer/List.vue'
import PramuniagaList from './pages/pramuniaga/List.vue'
import SupplierList from './pages/supplier/List.vue'

import ItemMutationList from './pages/item-mutation/List.vue'
import ItemMutationDetail from './pages/item-mutation/Detail.vue'
import ItemMutationCreate from './pages/item-mutation/Create.vue'
import ItemMutationBarcode from './pages/item-mutation/Barcode.vue'
import ItemMutationBon from './pages/item-mutation/Bon.vue'
import ItemMutationRemainingBon from './pages/item-mutation/RemainingBon.vue'
import ReprintBarcode from './pages/item-mutation/Reprint.vue'
import ReportMutationOutList from './pages/mutation-report/List.vue'
import ReportMutationOutListDetail from './pages/mutation-report/Detail.vue'
import ReportWarehouseStocks from './pages/mutation-report/StockReport.vue'
import ReportMutationPerSupplier from './pages/mutation-report/ListPerSupplier.vue'
import ItemMutationConfirmation from './pages/item-mutation/Confirmation.vue'
import PriceMutationList from './pages/price-mutation/List.vue'
import PriceMutationDetail from './pages/price-mutation/Detail.vue'
import PriceMutationCreate from './pages/price-mutation/Create.vue'
import PriceMutationBon from './pages/price-mutation/Bon.vue'
import PriceMutationBarcode from './pages/price-mutation/Barcode.vue'

import PurchaseList from './pages/purchase/List.vue'
import PurchaseDetail from './pages/purchase/Detail.vue'
import PurchaseEdit from './pages/purchase/Edit.vue'

import CategoryList from './pages/category/List.vue'
import CategoryDetail from './pages/category/Detail.vue'
import CategoryEdit from './pages/category/Edit.vue'
import CatalogList from './pages/catalog/List.vue'
import CatalogDetail from './pages/catalog/Detail.vue'
import ShiftList from './pages/shift/List.vue'
import StockImport from './pages/stock/Import.vue'
import VoucherList from './pages/voucher/List.vue'
import BonList from './pages/bon/List.vue'
import BonDetail from './pages/bon/Detail.vue'
import OutgoingList from './pages/outgoing/List.vue'
import OutgoingListDetail from './pages/outgoing/ListDetail.vue'
import OutgoingDetail from './pages/outgoing/Detail.vue'
import OutgoingCreate from './pages/outgoing/Create.vue'
import OutgoingSupplier from './pages/outgoing/CreateSupplier.vue'
import OutgoingPemutihan from './pages/outgoing/CreatePemutihan.vue'
import OutgoingKelebihan from './pages/outgoing/CreateKelebihan.vue'
import OutgoingKekurangan from './pages/outgoing/CreateKekurangan.vue'
import OutgoingTransfer from './pages/outgoing/Transfer.vue'
import ReceivingList from './pages/receiving/List.vue'
import ReceivingDetail from './pages/receiving/Detail.vue'
import ReceivingDetailAll from './pages/omset/DetailCodeItems.vue'
import ReceivingCreate from './pages/receiving/Create.vue'
import PrintOutgoing from './pages/receipt/ReturBon.vue'
import PrintPurchase from './pages/print/Purchase.vue'
import PrintItemsCondition from './pages/print/ItemsCondition.vue'
import PrintReceiving from './pages/print/Receiving.vue'
import ObralCreate from './pages/requestObral/Create.vue'
import ObralList from './pages/requestObral/List.vue'
import ObralDetail from './pages/requestObral/Detail.vue'
import ObralItem from './pages/itemObral/ItemObral.vue'
import StockOpnameCreate from './pages/stockopname/Create.vue'
import StockOpnameReview from './pages/stockopname/Review.vue'
import PrintStockOpname from './pages/print/StockOpname.vue'
import StockOpnameList from './pages/stockopname/List.vue'
import StockOpnameDetail from './pages/stockopname/Detail.vue'
import PrintCatalogList from './pages/print/CatalogList.vue'
import OutletList from './pages/outlet/List.vue'
import PrintVouchers from './pages/receipt/Voucher.vue'
import PrintDailyOmset from './pages/receipt/DailyOmset.vue'
import PrintDailyOmsetByCategory from './pages/receipt/DailyOmsetByCategory.vue'
import PrintAccumulationSellingGroup from './pages/receipt/AccumulationSellingGroup.vue'
import PrintAccumulationSelling from './pages/receipt/AccumulationSelling.vue'
import PrintReceiveList from './pages/receipt/ReceiveList.vue'
import PrintReportRefund from './pages/receipt/ReportRefund.vue'
import PrintSellPerformance from './pages/receipt/SellPerformance.vue'
import StockOpnameListOutlet from './pages/stockopname-outlet/List.vue'
import StockOpnameDetailOutlet from './pages/stockopname-outlet/Detail.vue'
import PrintStockOpnameOutlet from './pages/print/StockOpnameOutlet.vue'
import PrintReportCategory from './pages/receipt/ReportCategory.vue'
import TemporaryOmset from './pages/omset/Temporary.vue'
import DailyOmset from './pages/omset/Daily.vue'
import DailyOmsetByCategory from './pages/omset/DailyByCategory.vue'
import RecapOmset from './pages/omset/OmsetRecap.vue'
import ReportRefund from './pages/omset/Refund.vue'
import ReportCategory from './pages/omset/CategoryItems.vue'
import ReportCategoryBestSeller from './pages/omset/CategoryItemsBestSeller.vue'
import ItemsCondition from './pages/omset/NewItemsCondition.vue'
import SellPerformance from './pages/omset/SellPerformance.vue'
import ReportAccumulationSelling from './pages/omset/AccumulationSelling.vue'
import ReportAccumulationSellingGroup from './pages/omset/AccumulationSellingGroup.vue'
import laporanBarang from './pages/omset/CodeItems.vue'
import GrossProfit from './pages/profit/GrossProfit.vue'
import ExpenseList from './pages/expense/List.vue'
import ReceivingWarehouseList from './pages/warehouse-receiving/List.vue'
import ReceivingWarehouseDetail from './pages/warehouse-receiving/Detail.vue'
import WarehouseTransferCreate from './pages/warehouse-transfer/Create.vue'
import WarehouseTransferList from './pages/warehouse-transfer/List.vue'
import WarehouseTransferDetail from './pages/warehouse-transfer/Detail.vue'
import purchasingReceiveList from './pages/purchasing-receive/List.vue'
import purchasingReceiveDetail from './pages/purchasing-receive/Detail.vue'
import supplierReturList from './pages/supplier-retur/List.vue'
import supplierReturDetail from './pages/supplier-retur/Detail.vue'
import supplierReturCreate from './pages/supplier-retur/Create.vue'
import supplierReturFeedbackList from './pages/supplier-retur-feedback/List.vue'
import supplierReturFeedbackDetail from './pages/supplier-retur-feedback/Detail.vue'
import supplierReturFeedbackCreate from './pages/supplier-retur-feedback/Create.vue'
import PrintPurchasing from './pages/receipt/Purchasing.vue'
import purchasingReceiveListDestination from './pages/purchasing-receive/ListDestination.vue'
import ReportItemsInbound from './pages/omset/ItemsInbound.vue'
import ReceiptItemsPerMonth from './pages/receipt/RecepitItemsPerMonth.vue'
import ReceiptGroupItemsPerMonth from './pages/receipt/ReceiptGroupItemsPerMonth.vue'
import ReportSupplier from './pages/receipt/ReportingSupplier.vue'
import ReportSupplierPrint from './pages/print/ReportingSupplierPrint.vue'
import PrintMutationPerSupplier from './pages/print/ListPerSupplierPrint.vue'
import ReportItemsPerMonth from './pages/omset/ItemsPerMonth.vue'
import ReportGroupItemsPerMonth from './pages/omset/GroupItemsPerMonth.vue'
import ReportItemsAge from './pages/omset/ItemsAge.vue'
import PrintReportItemsAge from './pages/receipt/ItemsAge.vue'
import ReportStockConditionPerYear from './pages/omset/StockPerYearCondition.vue'
import PrintReportStockConditionPerYear from './pages/receipt/StockPerYearConditionPrint.vue'
import PrintSelectedCatalogList from './pages/print/SelectedCatalog.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/login', name: 'login', component: Login, meta: { auth: false } },

    {
      path: '',
      component: MainLayout,
      children: [
        {
          path: '/change-password',
          name: 'change-password',
          component: ChangePassword,
          meta: {
            auth: true,
            breadcrumb: [{ text: 'Ganti password' }]
          }
        },

        {
          path: '/',
          name: 'dashboard',
          component: Dashboard,
          meta: { auth: true }
        },

        {
          path: '/employee',
          name: 'employee',
          redirect: { name: 'employee-list' }
        },
        {
          path: '/employee/list',
          name: 'employee-list',
          component: EmployeeList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Daftar Pegawai'
              }
            ]
          }
        },

        {
          path: '/customer',
          name: 'customer',
          redirect: { name: 'customer-list' }
        },
        {
          path: '/customer/list',
          name: 'customer-list',
          component: CustomerList,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Pelanggan', to: { name: 'customer' } },
              { text: 'Daftar Pelanggan' }
            ]
          }
        },

        {
          path: '/pramuniaga/list',
          name: 'pramuniaga-list',
          component: PramuniagaList,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Pramuniaga', to: { name: 'pramuniaga-list' } },
              { text: 'Daftar Pramuniaga' }
            ]
          }
        },

        {
          path: '/supplier',
          name: 'supplier',
          redirect: { name: 'supplier-list' }
        },
        {
          path: '/supplier/list',
          name: 'supplier-list',
          component: SupplierList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Supplier',
                to: { name: 'supplier-list' }
              },
              { text: 'Daftar Supplier' }
            ]
          }
        },

        {
          path: '/item-mutation',
          name: 'item-mutation',
          redirect: { name: 'item-mutation-list' }
        },
        {
          path: '/report/mutation-out-list',
          name: 'report-mutation-out-list',
          component: ReportMutationOutList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-mutation-out-list' }
              },
              { text: 'Daftar Mutasi Keluar Barang' }
            ]
          }
        },
        {
          path: '/report/mutation-out-detail',
          name: 'report-mutation-out-detail',
          component: ReportMutationOutListDetail,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-mutation-out-list' }
              },
              {
                text: 'Laporan Mutasi Keluar Barang',
                to: { name: 'report-mutation-out-list' }
              },
              {
                text: 'Detail Mutasi Keluar Barang',
                to: { name: 'report-mutation-out-detail' }
              }
            ]
          }
        },
        {
          path: '/report/stock-warehosue',
          name: 'report-stock-warehouse',
          component: ReportWarehouseStocks,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-mutation-per-supplier' }
              },
              { text: 'Laporan Stok Barang' }
            ]
          }
        },
        {
          path: '/report/mutation-per-supplier',
          name: 'report-mutation-per-supplier',
          component: ReportMutationPerSupplier,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-mutation-per-supplier' }
              },
              { text: 'Laporan Mutasi Barang Per Supplier' }
            ]
          }
        },

        {
          path: '/item-mutation/list',
          name: 'item-mutation-list',
          component: ItemMutationList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Barang',
                to: { name: 'item-mutation-list' }
              },
              { text: 'Daftar Mutasi Barang' }
            ]
          }
        },
        {
          path: '/item-mutation/detail',
          name: 'item-mutation-detail',
          component: ItemMutationDetail,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Barang',
                to: { name: 'item-mutation-list' }
              },
              {
                text: 'Daftar Mutasi Barang',
                to: { name: 'item-mutation-list' }
              },
              { text: 'Detail Mutasi Barang' }
            ]
          }
        },
        {
          path: '/item-mutation/create',
          name: 'item-mutation-create',
          component: ItemMutationCreate,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Barang',
                to: { name: 'item-mutation-create' }
              },
              {
                text: 'Tambah Mutasi Barang',
                to: { name: 'item-mutation-create' }
              }
            ]
          }
        },
        {
          path: '/item-mutation/confrmation',
          name: 'item-mutation-confirmation',
          component: ItemMutationConfirmation,
          meta: { auth: true }
        },
        {
          path: '/item-mutation/barcode',
          name: 'item-mutation-barcode',
          component: ItemMutationBarcode,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Barang',
                to: { name: 'item-mutation-barcode' }
              },
              {
                text: 'Barcode',
                to: { name: 'item-mutation-barcode' }
              }
            ]
          }
        },
        {
          path: '/item-mutation/bon',
          name: 'item-mutation-bon',
          component: ItemMutationBon,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Barang',
                to: { name: 'item-mutation-bon' }
              },
              {
                text: 'Buat Bon',
                to: { name: 'item-mutation-bon' }
              }
            ]
          }
        },
        {
          path: '/item-mutation/remaining-bon',
          name: 'item-mutation-remaining-bon',
          component: ItemMutationRemainingBon,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Barang',
                to: { name: 'item-mutation-RemainingBon' }
              },
              {
                text: 'List Barcode Sisa',
                to: { name: 'item-mutation-RemainingBon' }
              }
            ]
          }
        },
        {
          path: '/item-mutation/Reprint',
          name: 'item-mutation-Reprint',
          component: ReprintBarcode,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Barang',
                to: { name: 'item-mutation-Reprint' }
              },
              {
                text: 'Cetak Ulang Barcode',
                to: { name: 'item-mutation-Reprint' }
              }
            ]
          }
        },

        {
          path: '/price-mutation',
          name: 'price-mutation',
          redirect: { name: 'price-mutation-list' }
        },
        {
          path: '/price-mutation/list',
          name: 'price-mutation-list',
          component: PriceMutationList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Harga',
                to: { name: 'price-mutation-list' }
              },
              {
                text: 'Daftar Mutasi Harga',
                to: { name: 'price-mutation-list' }
              }
            ]
          }
        },
        {
          path: '/price-mutation/detail',
          name: 'price-mutation-detail',
          component: PriceMutationDetail,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Harga',
                to: { name: 'price-mutation-list' }
              },
              {
                text: 'Daftar Mutasi Harga',
                to: { name: 'price-mutation-list' }
              },
              {
                text: 'Detail Mutasi Harga'
              }
            ]
          }
        },
        {
          path: '/price-mutation/create',
          name: 'price-mutation-create',
          component: PriceMutationCreate,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Harga',
                to: { name: 'price-mutation-create' }
              },
              {
                text: 'Tambah Mutasi Harga',
                to: { name: 'price-mutation-create' }
              }
            ]
          }
        },
        {
          path: '/price-mutation/bon',
          name: 'price-mutation-bon',
          component: PriceMutationBon,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Harga',
                to: { name: 'price-mutation-bon' }
              },
              {
                text: 'List Cetak Bon Mutasi Harga',
                to: { name: 'price-mutation-bon' }
              }
            ]
          }
        },
        {
          path: '/price-mutation/barcode',
          name: 'price-mutation-barcode',
          component: PriceMutationBarcode,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Mutasi Harga',
                to: { name: 'price-mutation-barcode' }
              },
              {
                text: 'List Cetak Harga',
                to: { name: 'price-mutation-barcode' }
              }
            ]
          }
        },
        {
          path: '/purchase',
          name: 'purchase',
          redirect: { name: 'purchase-list' }
        },
        {
          path: '/purchase/list',
          name: 'purchase-list',
          component: PurchaseList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Daftar Pembelian'
              }
            ]
          }
        },
        {
          path: '/purchase/detail',
          name: 'purchase-detail',
          component: PurchaseDetail,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Daftar Pembelian',
                to: { name: 'purchase-list' }
              }
            ]
          }
        },
        {
          path: '/purchase/edit',
          name: 'purchase-edit',
          component: PurchaseEdit,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Daftar Pembelian',
                to: { name: 'purchase-list' }
              },
              { text: 'Detail Pembelian' }
            ]
          }
        },

        {
          path: '/category',
          name: 'category',
          redirect: { name: 'category-list' }
        },
        {
          path: '/category/list',
          name: 'category-list',
          component: CategoryList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Kategori',
                to: { name: 'category-list' }
              },
              { text: 'Daftar Kategori' }
            ]
          }
        },
        {
          path: '/category/detail',
          name: 'category-detail',
          component: CategoryDetail,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Kategori',
                to: { name: 'category-list' }
              },
              { text: 'Daftar Kategori', to: { name: 'category-list' } },
              { text: 'Detail Kategori' }
            ]
          }
        },
        {
          path: '/category/edit',
          name: 'category-edit',
          component: CategoryEdit,
          props: true,
          meta: { auth: true }
        },

        {
          path: '/warehouse-transfer/create',
          name: 'warehouse-transfer-create',
          component: WarehouseTransferCreate,
          props: true,
          meta: { auth: true, breadcrumb: [{ text: 'Buat Transfer' }] }
        },

        {
          path: '/warehouse-transfer/detail',
          name: 'warehouse-transfer-detail',
          component: WarehouseTransferDetail,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Daftar Transfer',
                to: { name: 'warehouse-transfer-list' }
              },
              { text: 'Detail Transfer' }
            ]
          }
        },

        {
          path: '/warehouse-transfer/list',
          name: 'warehouse-transfer-list',
          component: WarehouseTransferList,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [{ text: 'Daftar Transfer' }]
          }
        },

        {
          path: '/purchasing-receive/detail',
          name: 'purchasing-receive-detail',
          component: purchasingReceiveDetail,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Transfer Barang',
                to: { name: 'purchasing-receive-list' }
              },
              {
                text: 'Daftar Transfer Barang',
                to: { name: 'purchasing-receive-list' }
              },
              { text: 'Detail Transfer Barang' }
            ]
          }
        },

        {
          path: '/purchasing-receive/list',
          name: 'purchasing-receive-list',
          component: purchasingReceiveList,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Transfer Barang',
                to: { name: 'purchasing-receive-list' }
              },
              { text: 'Daftar Transfer Barang' }
            ]
          }
        },

        {
          path: '/purchasing-receive/list-destination',
          name: 'purchasing-receive-list-destination',
          component: purchasingReceiveListDestination,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Transfer Barang',
                to: { name: 'purchasing-receive-list' }
              },
              { text: 'List Penerimaan Barang' }
            ]
          }
        },

        {
          path: '/catalog',
          name: 'catalog',
          redirect: { name: 'catalog-list' }
        },
        {
          path: '/catalog/list',
          name: 'catalog-list',
          component: CatalogList,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Catalog', to: { name: 'catalog-list' } },
              { text: 'Daftar Katalog' }
            ]
          }
        },
        {
          path: '/catalog/detail',
          name: 'catalog-detail',
          component: CatalogDetail,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Catalog', to: { name: 'catalog-list' } },
              { text: 'Daftar Katalog', to: { name: 'catalog-list' } },
              { text: 'Detail Item', to: { name: 'catalog-list' } }
            ]
          }
        },

        { path: '/shift', name: 'shift', redirect: { name: 'shift-list' } },
        {
          path: '/shift/list',
          name: 'shift-list',
          component: ShiftList,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Shift', to: { name: 'shift-list' } },
              { text: 'Daftar Shift' }
            ]
          }
        },
        { path: '/stock', name: 'stock', redirect: { name: 'stock-list' } },
        {
          path: '/stock/import',
          name: 'stock-import',
          component: StockImport,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Import Stock'
              }
            ]
          }
        },

        {
          path: '/stock-opname',
          name: 'stock-opname',
          redirect: { name: 'stock-opname-create' }
        },
        {
          path: '/stock-opname/create',
          name: 'stock-opname-create',
          component: StockOpnameCreate,
          meta: { auth: true }
        },
        {
          path: '/stock-opname/review',
          name: 'stock-opname-review',
          component: StockOpnameReview,
          meta: { auth: true }
        },
        {
          path: '/stock-opname/list',
          name: 'stock-opname-list',
          component: StockOpnameList,
          meta: { auth: true }
        },
        {
          path: '/stock-opname/detail',
          name: 'stok-opname-detail',
          component: StockOpnameDetail,
          props: true,
          meta: { auth: true }
        },

        {
          path: '/voucher',
          name: 'voucher',
          redirect: { name: 'voucher-list' }
        },
        {
          path: '/voucher/list',
          name: 'voucher-list',
          component: VoucherList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Daftar Pegawai'
              }
            ]
          }
        },

        { path: '/bon', name: 'bon', redirect: { name: 'bon-list' } },
        {
          path: '/bon/list',
          name: 'bon-list',
          component: BonList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Bon Toko',
                to: { name: 'bon-list' }
              },
              {
                text: 'Daftar Bon Toko',
                to: { name: 'bon-list' }
              }
            ]
          }
        },
        {
          path: '/bon/detail',
          name: 'bon-detail',
          component: BonDetail,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Bon Toko',
                to: { name: 'bon-list' }
              },
              {
                text: 'Daftar Bon Toko',
                to: { name: 'bon-list' }
              },
              { text: 'Detail Bon Mutasi Keluar Gudang' }
            ]
          }
        },

        {
          path: '/outgoing',
          name: 'outgoing',
          redirect: { name: 'outgoing-list' }
        },
        {
          path: '/outgoing/list',
          name: 'outgoing-list',
          component: OutgoingList,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Retur', to: { name: 'outgoing-list' } },
              { text: 'Daftar Retur & Transfer' }
            ]
          }
        },
        {
          path: '/outgoing/list-detail',
          name: 'outgoing-list-detail',
          component: OutgoingListDetail,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Retur', to: { name: 'outgoing-list' } },
              { text: 'Daftar Detail Retur & Transfer' }
            ]
          }
        },
        {
          path: '/outgoing/detail',
          name: 'outgoing-detail',
          component: OutgoingDetail,
          props: true,
          meta: {
            auth: true
            // breadcrumb: [
            //   { text: 'Retur', to: { name: 'outgoing-list' } },
            //   { text: 'Daftar Detail Retur & Transfer' }
            // ]
          }
        },
        {
          path: '/outgoing/create',
          name: 'outgoing-create',
          component: OutgoingCreate,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Retur', to: { name: 'outgoing-list' } },
              { text: 'Buat Retur Obral' }
            ]
          }
        },
        {
          path: '/outgoing/create/supplier',
          name: 'outgoing-create-supplier',
          component: OutgoingSupplier,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Retur', to: { name: 'outgoing-list' } },
              { text: 'Buat Retur Supplier' }
            ]
          }
        },
        {
          path: '/outgoing/create/pemutihan',
          name: 'outgoing-create-pemutihan',
          component: OutgoingPemutihan,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Retur', to: { name: 'outgoing-list' } },
              { text: 'Buat Retur Pemutihan' }
            ]
          }
        },
        {
          path: '/outgoing/create/kelebihan',
          name: 'outgoing-create-kelebihan',
          component: OutgoingKelebihan,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Retur', to: { name: 'outgoing-list' } },
              { text: 'Buat Retur Kelebihan' }
            ]
          }
        },
        {
          path: '/outgoing/create/kekurangan',
          name: 'outgoing-create-kekurangan',
          component: OutgoingKekurangan,
          meta: { auth: true }
        },
        {
          path: '/outgoing/transfer',
          name: 'outgoing-transfer',
          component: OutgoingTransfer,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Retur', to: { name: 'outgoing-list' } },
              { text: 'Transfer Item' }
            ]
          }
        },

        {
          path: '/receiving',
          name: 'receiving',
          redirect: { name: 'receiving-list' }
        },
        {
          path: '/receiving/list',
          name: 'receiving-list',
          component: ReceivingList,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Penerimaan Barang', to: { name: 'receiving-list' } },
              { text: 'Daftar Penerimaan Barang' }
            ]
          }
        },
        {
          path: '/receiving/detail',
          name: 'receiving-detail',
          component: ReceivingDetail,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Laporan Barang', to: { name: 'receiving-list' } },
              {
                text: 'Daftar Penerimaan Barang',
                to: { name: 'receiving-list' }
              },
              { text: 'Detail Penerimaan Barang' }
            ]
          }
        },
        {
          path: '/receiving/detail/all',
          name: 'receiving-detail-all',
          component: ReceivingDetailAll,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Penerimaan Barang', to: { name: 'customer' } },
              { text: 'Detail Penerimaan Barang' }
            ]
          }
        },
        {
          path: '/receiving/create',
          name: 'receiving-create',
          component: ReceivingCreate,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Penerimaan Barang', to: { name: 'receiving-create' } },
              { text: 'Buat Penerimaan Barang' }
            ]
          }
        },

        {
          path: '/obral',
          name: 'request-obral',
          redirect: { name: 'obral-list' }
        },
        {
          path: '/obral/create',
          name: 'obral-create',
          component: ObralCreate,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Buat Permintaan Barang Obral'
              }
            ]
          }
        },
        {
          path: '/obral/list',
          name: 'obral-list',
          component: ObralList,
          meta: {
            auth: true,
            breadcrumb: [{ text: 'Daftar Permintaan Barang Obral' }]
          }
        },
        {
          path: '/obral/detail',
          name: 'obral-detail',
          component: ObralDetail,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Daftar Permintaan Barang Obral',
                to: { name: 'obral-list' }
              },
              {
                text: 'Detail Permintaan Barang Obral'
              }
            ]
          }
        },
        {
          path: '/obral/item',
          name: 'obral-item',
          component: ObralItem,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Daftar Item Obral'
              }
            ]
          }
        },
        {
          path: '/outlet/list',
          name: 'outlet-list',
          component: OutletList,
          meta: { auth: true, breadcrumb: [{ text: 'Daftar Outlet' }] }
        },
        {
          path: '/omset/temporary',
          name: 'omset-temporary',
          component: TemporaryOmset,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Laporan Omset', to: { name: 'omset-temporary' } },
              { text: 'Temporary Omset' }
            ]
          }
        },
        {
          path: '/omset/daily',
          name: 'omset-daily',
          component: DailyOmset,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Laporan Omset', to: { name: 'omset-daily' } },
              { text: 'Daily Omset' }
            ]
          }
        },
        {
          path: '/omset/daily-by-category',
          name: 'omset-daily-by-category',
          component: DailyOmsetByCategory,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Omset',
                to: { name: 'omset-daily-by-category' }
              },
              { text: 'Daily Omset by Category' }
            ]
          }
        },
        {
          path: '/omset/recap',
          name: 'omset-recap',
          component: RecapOmset,
          meta: {
            auth: true,
            breadcrumb: [
              { text: 'Laporan Omset', to: { name: 'omset-recap' } },
              { text: 'Recap Omset' }
            ]
          }
        },
        {
          path: '/report/refund',
          name: 'report-refund',
          component: ReportRefund,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-refund' }
              },
              { text: 'Laporan Refund ' }
            ]
          }
        },
        {
          path: '/report/category',
          name: 'report-category',
          component: ReportCategory,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-category' }
              },
              { text: 'Laporan Kelompok Barang' }
            ]
          }
        },
        {
          path: '/report/category/best-seller',
          name: 'report-category-best-seller',
          component: ReportCategoryBestSeller,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-category-best-seller' }
              },
              { text: 'Laporan Kelompok Barang Best Seller' }
            ]
          }
        },
        {
          path: '/report/supplier-report',
          name: 'report-supplier',
          component: ReportSupplier,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-supplier' }
              },
              { text: 'Laporan Pendataan Supplier' }
            ]
          }
        },
        {
          path: '/report/item-inbound',
          name: 'report-items-items-inbound',
          component: ReportItemsInbound,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-items-items-inbound' }
              },
              { text: 'Laporan Barang Masuk Per Bon ' }
            ]
          }
        },
        {
          path: '/report/item-per-month',
          name: 'report-items-per-month',
          component: ReportItemsPerMonth,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-items-per-month' }
              },
              { text: 'Laporan Barang Masuk Per Bulan ' }
            ]
          }
        },
        {
          path: '/report/group-item-per-month',
          name: 'report-group-items-per-month',
          component: ReportGroupItemsPerMonth,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-group-items-per-month' }
              },
              { text: 'Laporan Barang Masuk Per Bulan Per Kelompok Barang ' }
            ]
          }
        },
        {
          path: '/report/items-age',
          name: 'report-items-age',
          component: ReportItemsAge,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-items-age' }
              },
              { text: 'Laporan Usia Barang Per Kode Barang' }
            ]
          }
        },
        {
          path: '/report/stock-condition-per-year',
          name: 'stock-condition-per-year',
          component: ReportStockConditionPerYear,
          props: true,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'stock-condition-per-year' }
              },
              { text: 'Riwayat Stok Barang Per Tahun' }
            ]
          }
        },
        {
          path: '/report/items-condition',
          name: 'report-items-condition',
          component: ItemsCondition,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-items-condition' }
              },
              { text: 'Laporan Kondisi Stok Barang' }
            ]
          }
        },
        {
          path: '/report/sell-performance',
          name: 'report-sell-performance',
          component: SellPerformance,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-sell-performance' }
              },
              { text: 'Laporan Performa Penjualan' }
            ]
          }
        },
        {
          path: '/report/stock-opname-outlet-list',
          name: 'report-stock-opname-outlet-list',
          component: StockOpnameListOutlet,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-stock-opname-outlet-list' }
              },
              { text: 'Daftar Stock Opname' }
            ]
          }
        },
        {
          path: '/report/stok-opname-outlet-detail',
          name: 'report-stok-opname-outlet-detail',
          component: StockOpnameDetailOutlet,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-stock-opname-outlet-list' }
              },
              {
                text: 'Daftar Stock Opname',
                to: { name: 'report-stock-opname-outlet-list' }
              },

              {
                text: 'Daftar Stock Opname',
                to: { name: 'report-stok-opname-outlet-detail' }
              }
            ]
          }
        },
        {
          path: '/report/category/accumulation-selling',
          name: 'report-category-accumulation-selling',
          component: ReportAccumulationSelling,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-category-accumulation-selling' }
              },
              { text: 'Laporan Akumulasi Penjualan Harian' }
            ]
          }
        },
        {
          path: '/report/category/accumulation-selling-group',
          name: 'report-category-accumulation-selling-group',
          component: ReportAccumulationSellingGroup,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'report-category-accumulation-selling' }
              },
              { text: 'Laporan Akumulasi Penjualan Bulanan' }
            ]
          }
        },

        {
          path: '/supplier-retur/list',
          name: '/supplier-retur/list',
          component: supplierReturList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Retur Supplier',
                to: { name: '/supplier-retur/list' }
              },
              { text: 'List Retur Supplier' }
            ]
          }
        },
        {
          path: '/supplier-retur/create',
          name: 'supplier-retur-create',
          component: supplierReturCreate,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Retur Supplier',
                to: { name: '/supplier-retur/list' }
              },
              { text: 'Buat Retur Supplier' }
            ]
          }
        },
        {
          path: '/supplier-retur/detail',
          name: 'supplier-retur-detail',
          component: supplierReturDetail,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Retur Supplier',
                to: { name: '/supplier-retur/list' }
              },
              {
                text: 'List Retur Supplier',
                to: { name: '/supplier-retur/list' }
              },
              { text: 'Detail Retur Supplier' }
            ]
          }
        },
        {
          path: '/supplier-retur-feedback/list',
          name: '/supplier-retur-feedback/list',
          component: supplierReturFeedbackList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Retur Supplier Feedback',
                to: { name: '/supplier-retur-feedback/list' }
              },
              {
                text: 'List Retur Supplier Feedback',
                to: { name: '/supplier-retur-feedback/list' }
              }
            ]
          }
        },

        {
          path: '/supplier-retur-feedback/detail',
          name: 'supplier-retur-feedback-detail',
          component: supplierReturFeedbackDetail,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Retur Supplier Feedback',
                to: { name: '/supplier-retur-feedback/list' }
              },
              {
                text: 'List Retur Supplier Feedback',
                to: { name: '/supplier-retur-feedback/list' }
              },
              { text: 'Detail Retur Supplier' }
            ]
          }
        },

        {
          path: '/supplier-retur-feedback/create',
          name: 'supplier-retur-feedback-create',
          component: supplierReturFeedbackCreate,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Retur Supplier Feedback',
                to: { name: '/supplier-retur-feedback-create' }
              },
              {
                text: 'Buat Retur Supplier Feedback',
                to: { name: '/supplier-retur-feedback-create' }
              }
            ]
          }
        },

        {
          path: '/report/barang',
          name: 'laporan-Barang',
          component: laporanBarang,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Laporan Barang',
                to: { name: 'laporan-barang' }
              },
              { text: 'Laporan Stok Barang' }
            ]
          }
        },
        {
          path: '/gross-profit/list',
          name: 'gross-profit',
          component: GrossProfit,
          meta: { auth: true }
        },
        {
          path: '/expense/list',
          name: 'expense-list',
          component: ExpenseList,
          meta: { auth: true }
        },
        {
          path: '/receiving-warehouse/list',
          name: 'receiving-warehouse-list',
          component: ReceivingWarehouseList,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Daftar Retur Barang'
              }
            ]
          }
        },
        {
          path: '/receiving-warehouse/detail',
          name: 'receiving-warehouse-detail',
          component: ReceivingWarehouseDetail,
          meta: {
            auth: true,
            breadcrumb: [
              {
                text: 'Daftar Retur Barang',
                to: { name: 'receiving-warehouse-list' }
              },
              { text: 'Detail Retur Barang' }
            ]
          }
        },

        {
          path: '',
          component: PrintLayout,
          children: [
            {
              path: '/print/purchase',
              name: 'print-purchase',
              props: true,
              component: PrintPurchase,
              meta: { auth: true }
            },
            {
              path: '/print/stock-opname',
              name: 'print-stock-opname',
              props: true,
              component: PrintStockOpname,
              meta: { auth: true }
            }
          ]
        }
      ]
    },
    {
      path: '',
      component: ReceiptLayout,
      children: [
        {
          path: '/print/retur',
          name: 'print-retur-bon',
          props: true,
          component: PrintOutgoing,
          meta: { auth: true }
        },
        {
          path: '/print/vouchers',
          name: 'print-vouchers',
          props: true,
          component: PrintVouchers,
          meta: { auth: true }
        },
        {
          path: '/print/daily-omset',
          name: 'print-daily-omset',
          props: true,
          component: PrintDailyOmset,
          meta: { auth: true }
        },
        {
          path: '/print/daily-omset-by-category',
          name: 'print-daily-omset-by-category',
          props: true,
          component: PrintDailyOmsetByCategory,
          meta: { auth: true }
        },
        {
          path: '/print/items-condition',
          name: 'print-items-condition',
          props: true,
          component: PrintItemsCondition,
          meta: { auth: true }
        },
        {
          path: '/print/accumulation-selling-group',
          name: 'print-accumulation-selling-group',
          props: true,
          component: PrintAccumulationSellingGroup,
          meta: { auth: true }
        },
        {
          path: '/print/supplier-report',
          name: 'print-supplier-report',
          component: ReportSupplierPrint,
          props: true,
          meta: { auth: true }
        },
        {
          path: '/print/mutation-per-supplier',
          name: 'print-mutation-per-supplier',
          component: PrintMutationPerSupplier,
          props: true,
          meta: { auth: true }
        },
        {
          path: '/print/accumulation-selling',
          name: 'print-accumulation-selling',
          props: true,
          component: PrintAccumulationSelling,
          meta: { auth: true }
        },
        {
          path: '/print/receive-list',
          name: 'print-receive-list',
          props: true,
          component: PrintReceiveList,
          meta: { auth: true }
        },
        {
          path: '/print/report-refund',
          name: 'print-report-refund',
          props: true,
          component: PrintReportRefund,
          meta: { auth: true }
        },
        {
          path: '/print/sell-performance',
          name: 'print-sell-performance',
          props: true,
          component: PrintSellPerformance,
          meta: { auth: true }
        },
        {
          path: '/print/report-category',
          name: 'print-report-category',
          props: true,
          component: PrintReportCategory,
          meta: { auth: true }
        },
        {
          path: '/receipt/purchasing',
          name: 'print-purchasing',
          props: true,
          component: PrintPurchasing,
          meta: { auth: true }
        },
        {
          path: '/report/item-per-month/print',
          name: 'print-report-items-per-month',
          component: ReceiptItemsPerMonth,
          meta: { auth: true }
        },
        {
          path: '/report/group-item-per-month/print',
          name: 'print-report-group-items-per-month',
          component: ReceiptGroupItemsPerMonth,
          meta: { auth: true }
        },
        {
          path: '/print/report-items-age',
          name: 'print-report-items-age',
          component: PrintReportItemsAge,
          props: true,
          meta: { auth: true }
        },
        {
          path: '/print/report-group-stock-condition',
          name: 'print-report-group-stock-condition',
          component: PrintReportStockConditionPerYear,
          props: true,
          meta: { auth: true }
        }
      ]
    },
    {
      path: '/print/receiving',
      name: 'print-receiving',
      props: true,
      component: PrintReceiving,
      meta: { auth: true }
    },
    {
      path: '/print/catalog-list',
      name: 'print-catalog-list',
      props: true,
      component: PrintCatalogList,
      meta: { auth: true }
    },
    {
      path: '/print/selected-catalog-list',
      name: 'print-selected-catalog-list',
      props: true,
      component: PrintSelectedCatalogList,
      meta: { auth: true }
    },
    {
      path: '/print/stock-opname-outlet',
      name: 'print-stock-opname-outlet',
      component: PrintStockOpnameOutlet,
      meta: { auth: true },
      props: true
    }
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach(function (to, from, next) {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  if (to.meta && to.meta.auth !== undefined) {
    if (to.meta.auth) {
      if (vueAuthInstance.isAuthenticated()) {
        next()
      } else {
        router.push({
          name: 'login'
        })
      }
    } else {
      if (vueAuthInstance.isAuthenticated()) {
        router.push({
          name: to.meta.to
        })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
